import React, { useEffect, useState, useLayoutEffect } from "react";
import HomeStyle from "./style";
import { Route, withRouter } from "react-router";

// components
import Loader from "../../Container/Loader";
import Modal from "../../Container/Modal";
import FullSidebarSettings from "../../Container/FullPageSidebar/services";

import Icon from "../../Assets/earnings.svg";
import Sort from "../../Assets/sort.svg";
import DeleteIcon from "../../Assets/Delete.svg";
import Pen from "../../Assets/pen.svg";
import Handle from "../../Assets/handle.svg";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

// -- redux
import { connect } from "react-redux";
import {
  GetSettings,
  UpdateSettingStatus,
  DeleteSetting,
  UpdateSettingOrderStatus,
} from "../../Redux/Actions/SettingsAction";

function Settings(props) {
  const initialPath = process.env.REACT_APP_IMAGE_BASE_URL;
  const [OpenModal, setModal] = useState(false);
  const [SettingId, setSettingId] = useState(false);
  const [InitialArray, setInitialArray] = useState([]);
  const [Name, setName] = useState(false);
  const [tableEntries, setTableEntries] = useState([]);
  const showAMPM = (time) => {
    let AMPM = "";
    let hourStr = "";
    let minStr = "";
    if (time) {
      let hours = parseInt(time.split(":")[0], 10);
      let minutes = parseInt(time.split(":")[1], 10);
      if (hours > 11) {
        if (hours > 12) hours = hours - 12;
        AMPM = "PM";
      } else {
        AMPM = "AM";
        if (hours === 0) hours = 12;
      }
      if (hours < 10) {
        hourStr = "0" + String(hours);
      } else {
        hourStr = String(hours);
      }
      if (minutes < 10) {
        minStr = "0" + String(minutes);
      } else {
        minStr = String(minutes);
      }
      return hourStr + " : " + minStr + " " + AMPM;
    } else {
      return time;
    }
  };

  useEffect(() => {
    let data = {
      status: props.status,
      user_type: props.userData,
      module_type: 1,
    };
    props.GetSettings(data);
  }, [
    props.update_data,
    props.delete_data,
    props.location.back,
    props.status,
    props.userData,
    props.order_data,
    props.edit_data,
    props.add_data,
  ]);

  useEffect(() => {
    if (props.data && props.data.data && props.data.data.data) {
      props.enabled(props.data.data.enabled);
      props.disabled(props.data.data.disabled);
      setInitialArray(props.data.data.data);
      props.clear("");
    }
  }, [
    props.data,
    props.update_data,
    props.delete_data,
    props.edit_data,
    props.add_data,
  ]);

  useEffect(() => {
    props.clear("clear");
  }, []);

  useEffect(() => {
    if (props.data && props.data.data && props.data.data.data) {
      InitialArray.map((item, index) => {
        item.type === 1 && (InitialArray[index].display_type = "Tab");
        item.type === 2 && (InitialArray[index].display_type = "App");
        item.type === 3 && (InitialArray[index].display_type = "Service");
        item.type === 4 && (InitialArray[index].display_type = "Webview");
        item.type === 5 && (InitialArray[index].display_type = "Form");
        InitialArray[index].sort_title = item.title.toLowerCase();
      });
      setTableEntries(InitialArray);
    }
  }, [InitialArray]);

  useLayoutEffect(() => {
    setTimeout(() => {
      if (
        props.location.method &&
        props.location.method === "add" &&
        props.add_data
      ) {
        let res = props.add_data;
        res.message = res.message.replace("Service", "Setting");
        props.respType({
          type: "Setting",
          method: props.location.method,
          response: res,
        });
      }
    }, 1500);
  }, [props.add_data]);

  useLayoutEffect(() => {
    setTimeout(() => {
      if (
        props.location.method &&
        props.location.method === "update" &&
        props.edit_data
      ) {
        let res = props.edit_data;
        res.message = res.message.replace("Service", "Setting");
        props.respType({
          type: "Setting",
          method: props.location.method,
          response: res,
        });
      }
    }, 1500);
  }, [props.edit_data]);

  useLayoutEffect(() => {
    setTimeout(() => {
      if (
        props.location.method &&
        props.location.method === "delete" &&
        props.delete_data
      ) {
        let res = props.delete_data;
        res.message = res.message.replace("Service", "Setting");
        props.respType({
          type: "Setting",
          method: props.location.method,
          response: res,
        });
      }
    }, 1500);
  }, [props.delete_data]);

  const handleModal = (e, type, name, id) => {
    e.preventDefault();
    setModal(type);
    setName(name);
    setSettingId(id);
  };

  const CloseModal = (e, type) => {
    e.preventDefault();
    if (type === "enable_yes") {
      let body = {
        id: SettingId,
        status: 0,
      };
      props.UpdateSettingStatus(body);
    } else {
      setModal(!OpenModal);
    }
    if (type === "disable_yes") {
      let body = {
        id: SettingId,
        status: 1,
      };
      props.UpdateSettingStatus(body);
    } else {
      setModal(!OpenModal);
    }
    if (type === "delete_yes") {
      props.DeleteSetting(SettingId);
      setModal(false);
    } else if (type === "delete_no") {
      setModal(false);
    }
  };

  const Search = props.Search;
  useEffect(() => {
    if (!Search) {
      setTableEntries(InitialArray);
    }
    if (props.Search.length > 2) {
      const FilteredArray = InitialArray.filter((post) => {
        const postName = post.title;
        return postName.toLowerCase().includes(Search.toLowerCase());
      });
      setTableEntries(FilteredArray);
    }
  }, [Search]);

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(tableEntries);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setTableEntries(items);
    passData(items);
  };

  const passData = (items) => {
    let data = [];
    items.map((arr) => {
      let index = items.findIndex((x) => x.title === arr.title);
      let id = items.filter((x) => x.id === arr.id);
      data.push({
        id: id[0].id,
        order_number: index + 1,
      });
    });
    props.UpdateSettingOrderStatus(data);
  };

  const changePage = (item) => {
    props.history.push({
      pathname: "settings/edit-services",
      state: item,
      page: "settings",
    });
  };

  return (
    <>
      {props.loading && <Loader />}
      <div className="ml-4 mr-4">
        <Route
          exact
          path={[
            "/dashboard/settings/add-services",
            "/dashboard/settings/edit-services",
          ]}
          component={FullSidebarSettings}
        />
        {props.location.pathname === "/dashboard/settings" && (
          <div className="module-table-wrap table-responsive">
            <div className="table-wrap">
              <table className="table table-bordered">
                <thead className="text-grey-6">
                  <tr>
                    <th scope="col" className="dark-background" />
                    <th scope="col" className="dark-background">
                      <div className="d-flex">
                        <span className="f-16">Icon</span>
                      </div>
                    </th>
                    <th scope="col" className="dark-background cursor-pointer">
                      <div className="d-flex justify-content-between mr-5">
                        <span className="f-16">Title </span>
                      </div>
                    </th>
                    <th scope="col" className="dark-background">
                      <div className="d-flex">
                        <span className="f-16">
                          List of <br /> Questions
                        </span>
                      </div>
                    </th>
                    <th scope="col" className="dark-background">
                      <div className="d-flex">
                        <span className="f-16">Header Title</span>
                      </div>
                    </th>
                    <th scope="col" className="dark-background">
                      <div className="d-flex">
                        <span className="f-16">
                          New Request
                          <br /> Button Title
                        </span>
                      </div>
                    </th>
                    <th scope="col" className="dark-background">
                      <div className="d-flex">
                        <span className="f-16">User type</span>
                      </div>
                    </th>
                    <th scope="col" className="dark-background">
                      <div className="d-flex">
                        <span className="f-16">Start Time</span>
                      </div>
                    </th>
                    <th scope="col" className="dark-background">
                      <div className="d-flex">
                        <span className="f-16">End Time</span>
                      </div>
                    </th>
                    <th scope="col" className="dark-background cursor-pointer">
                      <div className="d-flex justify-content-between">
                        <span className="f-16">Type</span>
                      </div>
                    </th>
                    <th scope="col" className="dark-background">
                      <div className="d-flex">
                        <span className="f-16">Status</span>
                      </div>
                    </th>
                    <th scope="col" className="dark-background">
                      <div className="d-flex">
                        <span className="f-16">Action</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <DragDropContext onDragEnd={handleOnDragEnd}>
                  <Droppable droppableId="home_listing" type="listing">
                    {(provided) => (
                      <tbody
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {tableEntries.length > 0 ? (
                          tableEntries.map((item, index) => {
                            return (
                              <Draggable
                                key={item.id}
                                draggableId={item.id.toString()}
                                index={index}
                              >
                                {(provided) => (
                                  <tr
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    key={index}
                                  >
                                    <td
                                      style={{ width: "69px" }}
                                      className="light-grey-background"
                                    >
                                      <img
                                        className="pl-4 pr-4"
                                        src={Handle}
                                        alt="Handle"
                                      />
                                    </td>
                                    <td
                                      style={{ width: "79px" }}
                                      className="light-grey-background"
                                    >
                                      <img
                                        width="40"
                                        src={item.icon}
                                        className="pl-1 pr-1"
                                        alt="icon"
                                      />
                                    </td>
                                    <td
                                      style={{ width: "132px" }}
                                      className="light-grey-background"
                                    >
                                      <span className="text-white pl-2 pr-2">
                                        {item.title}
                                      </span>
                                    </td>
                                    <td
                                      style={{ width: "191px" }}
                                      className="light-grey-background"
                                    >
                                      <span className="text-white pl-1">
                                        {item.question_count}
                                      </span>
                                    </td>
                                    <td
                                      style={{
                                        whiteSpace: "unset",
                                        wordBreak: "break-all",
                                      }}
                                      className="light-grey-background"
                                    >
                                      <p
                                        className="text-white m-0 pl-2"
                                        style={{ width: "239px" }}
                                      >
                                        {item.header_title}
                                      </p>
                                    </td>
                                    <td
                                      style={{
                                        width: "239px",
                                        whiteSpace: "unset",
                                        wordBreak: "break-all",
                                      }}
                                      className="light-grey-background"
                                    >
                                      <p
                                        className="text-white m-0 pl-2"
                                        style={{ width: "239px" }}
                                      >
                                        {item.request_button_title}
                                      </p>
                                    </td>
                                    <td
                                      style={{ width: "118px" }}
                                      className="light-grey-background"
                                    >
                                      <span className="text-white pl-2">
                                        {item.user_type == 1 && "Both"}
                                        {item.user_type == 2 && "Personal Banking"}
                                        {item.user_type == 3 && "Business"}
                                      </span>
                                    </td>
                                    <td
                                      style={{ width: "125px" }}
                                      className="light-grey-background"
                                    >
                                      <span className="text-white pl-1">
                                        {item.start_time &&
                                          showAMPM(item.start_time)}
                                      </span>
                                    </td>
                                    <td
                                      style={{ width: "82px" }}
                                      className="light-grey-background"
                                    >
                                      <span className="text-white pl-1">
                                        {item.end_time &&
                                          showAMPM(item.end_time)}
                                      </span>
                                    </td>
                                    <td
                                      style={{ width: "87px" }}
                                      className="light-grey-background"
                                    >
                                      <span className="text-white pl-1">
                                        {item.display_type}
                                      </span>
                                    </td>
                                    <td
                                      className="text-center pl-4 pr-4 light-grey-background"
                                      style={{ width: "108px" }}
                                    >
                                      <label className="switch mb-0">
                                        <input
                                          type="checkbox"
                                          checked={item.status === 1}
                                          readOnly
                                          onClick={(e) =>
                                            handleModal(
                                              e,
                                              item.status === 1
                                                ? "enable"
                                                : "disable",
                                              item.title,
                                              item.id
                                            )
                                          }
                                        />
                                        <span className="slider round" />
                                      </label>
                                    </td>
                                    <td
                                      style={{ width: "95px" }}
                                      className="light-grey-background"
                                    >
                                      <div className="d-flex">
                                        <img
                                          onClick={() => changePage(item.id)}
                                          src={Pen}
                                          alt="pen"
                                          className="ml-2 mr-2 cursor-pointer"
                                        />
                                        <img
                                          onClick={(e) =>
                                            handleModal(
                                              e,
                                              "delete",
                                              item.title,
                                              item.id
                                            )
                                          }
                                          src={DeleteIcon}
                                          alt="Delete"
                                          className="ml-2 cursor-pointer"
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </Draggable>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="12" className="text-center">
                              <b className="text-white">Not found</b>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    )}
                  </Droppable>
                </DragDropContext>
              </table>
            </div>
            <HomeStyle />
          </div>
        )}
        {OpenModal && (
          <Modal
            Name={Name}
            Type={OpenModal}
            Close={(e, type) => CloseModal(e, type)}
          />
        )}
      </div>
    </>
  );
}

const mapStateToProps = ({ SettingsReducer, ServicesReducer }) => {
  const { loading, table_loading, data, update_data, order_data } = SettingsReducer;
  const { delete_data, add_data, edit_data } = ServicesReducer;
  return {
    loading,
    table_loading,
    data,
    delete_data,
    update_data,
    order_data,
    add_data,
    edit_data,
  };
};

const mapDispatchToProps = {
  GetSettings,
  UpdateSettingStatus,
  DeleteSetting,
  UpdateSettingOrderStatus,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Settings));
